import React from 'react'
import { THEME, abbreviateNumber, countdownAsObject } from 'utils'
import AvatarIcon from 'icons/Avatar'
import TimeDependent from 'components/TimeDependent'
import SharingLinks from 'components/SharingLinks'

const LiveMeta = ({ story, viewerCount }) => (
  <>
    <div className='liveMeta'>
      <div className='liveMeta__left'>
        {story.post_type_meta.live.status === 'post' ? (
          <span className='liveCountdown'>
            <span className='liveCountdown__label'>Ended</span>
          </span>
        ) : (
          <TimeDependent
            date={story.post_type_meta.live.datetime}
            renderBefore={(timeProps) => {
              const { value } = countdownAsObject(timeProps, story.post_type_meta.live.datetime)
              return (
                <span className='liveCountdown'>
                  <span className='liveCountdown__label'>Starts In: </span>
                  {value}
                </span>
              )
            }}
            renderAfter={() => <span className='liveIndicator'>Live</span>}
          />
        )}
        <div className='viewerCount'>
          <AvatarIcon color='#5A616E' width='auto' height='16px' />
          <span className='count'>{abbreviateNumber(viewerCount)}</span>
        </div>
      </div>
      <div className='liveMeta__right'>
        <SharingLinks story={story} live location='liveStoryTab' />
      </div>
    </div>
    <style jsx>{`
      .liveMeta {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 5px 0 0 0;
      }
      .liveMeta__left {
        display: flex;
        align-items: center;
      }
      .viewerCount {
        display: flex;
        align-items: center;
      }
      .liveCountdown__label,
      .liveIndicator,
      .count {
        font-family: ${THEME.FONTS.BEBAS};
        text-transform: uppercase;
        display: block;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0.58px;
        color: #5a616e;
      }
      .liveIndicator {
        color: ${THEME.COLORS.PRIMARY};
        margin-right: 10px;
      }
      .count {
        margin-left: 4px;
      }
      .liveCountdown {
        display: flex;
        align-items: center;
        margin-right: 15px;
        color: #5a616e;
        font-weight: 600;
      }
      .liveCountdown__label {
        color: ${THEME.COLORS.PRIMARY};
        margin-right: 5px;
      }
      @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
        .liveMeta {
          padding-top: 20px;
        }
      }
    `}</style>
  </>
)

export default LiveMeta
